import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchLevelAvailableList = createAsyncThunk("fetchLevelAvailableList", async ({ filters }) => {
	const company = filters && filters.company !== undefined ? `${filters.company}` : "";
	const stratum = filters && filters.stratum !== undefined ? `${filters.stratum}` : "";

	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`level/available/list?stratum=${stratum}&company=${company}`, config);


	return response.data?.data;
});

const levelListAvailableSlice = createSlice({
	name: "levelListAvailableSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchLevelAvailableList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchLevelAvailableList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchLevelAvailableList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default levelListAvailableSlice.reducer;
